// @flow strict
const sortDirection = {
    ASC: 'asc',
    DESC: 'desc'
};

export type TSortDirection = $Values<typeof sortDirection>;

export default sortDirection;
